import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';

function PaginatedItems({ itemsPerPage, items }) {

    const { t, i18n } = useTranslation();
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, items]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <div className='md:max-w-container max-w-containerSm mx-auto grid grid-cols-1 md:grid-cols-4 gap-4 p-4'>
        {currentItems && currentItems.map((item, index) => (
          <div className='bg-[white] rounded-[20px] w-[310px] min-h-[310px] px-6 py-4 mx-auto md:mx-0 border border-[#949494]' key={index}>
          <div className='m-3 text-[black]'>
            <div className='bg-[white] rounded-xl h-[167px] mb-3 flex justify-center items-center'>
              <img className='h-[160px] mx-auto' src={`https://www.tanura.az/tanura/${item.image}`} alt='' />
            </div>
            <h3 className='text-left text-[16px] font-medium'>{item.name}</h3>
            <a key={item.id} href={`/product-detail/${item.id}`}><button className='w-full mt-4 h-[40px] border border-[#223077] rounded-xl hover:bg-[#023077] hover:text-[white] transition-transform duration-300 ease-in-out'>{t("Ətraflı bax")}</button></a>
          </div>
        </div>
        ))}
      </div>

      <ReactPaginate
        nextLabel="sonrakı"
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        pageCount={pageCount}
        previousLabel="əvvəlki"
        renderOnZeroPageCount={null}
        containerClassName="flex justify-center items-center space-x-1 my-4"
        pageClassName="inline-block px-2 py-1 text-sm md:text-base rounded bg-gray-200 hover:bg-gray-300"
        previousClassName="inline-block px-2 py-1 text-sm md:text-base rounded bg-gray-200 hover:bg-gray-300"
        nextClassName="inline-block px-2 py-1 text-sm md:text-base rounded bg-gray-200 hover:bg-gray-300"
        activeClassName="bg-blue-600 text-white"
        disabledClassName="text-gray-400 cursor-not-allowed"
      />
    </>
  );
}

export default PaginatedItems;

